import React, { FC } from 'react';
import moment from 'moment';
import classNames from 'classnames/bind';
import Text from '../../../../../atoms/Text';
import Image from '../../../../../atoms/ImageView';
import EventTimer from '../../../EventTimer';
import { UPCOMING_EVENT_START_TEXT } from '../../../Constants';
import { getDayString } from '../../../utils/TopShopperDateUtils';
import styles from './index.pcss';

const cx = classNames.bind(styles);

interface UpcomingEventCardProps {
  imgSrc: string;
  rewardTitle: string;
  rewardDesc: string;
  date: string;
  startTime: number;
  endTime: number;
  timer: string;
}

const UpcomingEventCard: FC<UpcomingEventCardProps> = (
  props: UpcomingEventCardProps
): JSX.Element => {
  const { imgSrc, rewardTitle, rewardDesc, date, timer, startTime, endTime } = props;
  return (
    <article>
      <div className={cx('wrapper')}>
        <div className={cx('card-container')}>
          <div className={cx('reward-details')}>
            <div className={cx('image')}>
              <Image src={imgSrc} alt="reward-image" />
            </div>
            <div className={cx('title')}>
              <Text variant="T4" color="White" weight="bold">
                {rewardTitle}
              </Text>
            </div>
            <div className={cx('desctiption')}>
              <Text variant="T3" color="White">
                {rewardDesc}
              </Text>
            </div>
          </div>
          <div className={cx('time-details')}>
            <div className={cx('day')}>
              <Text variant="T4" color="White" weight="bold">
                {`${getDayString(date)} : `}
              </Text>
              <Text variant="T4" color="White" weight="bold">
                {`${moment(startTime).format('hA')} - ${moment(endTime).format('hA')}`}
              </Text>
            </div>
            <div className={cx('time')}>
              <EventTimer
                variant="T2"
                weight="bold"
                color="Jade"
                title="Event Starts in"
                timerClass="upcoming-event-timer"
                rootTextColorClass="White"
                eventDate={startTime}
                topLevelComponent="upcoming"
                onTimerComplete={() => console.log('timer end')}
              />
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default UpcomingEventCard;
